import getSubstringBeforeFindString from '../helpers/getSubstringBeforeFindString'
import getSubstringAfterFindString from '../helpers/getSubstringAfterFindString'
//------------------------
// get skill summary cols
//------------------------
export default function getSkillSummaryCols(active_tab, headings) {
  // console.log('-----------------------')
  // console.log('IN getSkillSummaryCols active_tab:', active_tab)
  let colNumbers = []
  let fields = []
  //------------------
  // check active tab
  //------------------
  let tab_suffix = getSubstringAfterFindString(active_tab, 'skills-')
  let tab_prefix = getSubstringBeforeFindString(active_tab, '-')
  // console.log('Tab prefix:', tab_prefix)
  // console.log('Tab suffix:', tab_suffix)
  //------------------------
  // set field cols to show
  //------------------------
  if (tab_prefix === 'skills') {
    fields = [
      'rowNumber',
      'name',
      'cur',
      'fill1',
      'cur_no_adjs',
      'incr_percent',
      'fill2',
      'formula',
      'favourite_image',
      'base',
      'ticks',
      'training',
      'fill3',
      'adjs_tot',
      'action_adjust',
      'fill4',
      'adjs_cnt_opt',
      'action_adjust_opt',
    ]
    if (tab_suffix === 'all') {
      fields.splice(2, 0, 'type')
    }
    // summary set remains common across tabs; type/extra columns are
    // controlled via headings/toggle logic elsewhere.
    //-----------------------------------
    // option fields for specialisms tab
    //-----------------------------------
    if (tab_suffix === 'specialisms') {
      fields.push('parent_name', 'action_delete')
      //--------------------------
      // option fields for runes tab
      //-----------------------------
    } else if (tab_suffix === 'runes') {
      fields.push('integrated_rune_image')
    } else if (tab_suffix === 'casting') {
      fields.splice(2, 0, 'spell_type', 'integrated_rune_image', 'spell_count')
    } else if (tab_suffix === 'melee-weapons' || tab_suffix === 'ranged-weapons') {
      const favIdx = fields.indexOf('favourite_image')
      if (favIdx !== -1) {
        fields.splice(favIdx, 0, 'usable_image')
      } else {
        fields.push('usable_image')
      }
    }
    // } else {
    //   console.warn('*** getSkillSummaryCols - Unknown sheet:', active_tab)
  }
  //--------------------------------
  // get headings idx for col names
  //--------------------------------
  for (let k = 0; k < fields.length; k++) {
    let idx = headings.findIndex((a) => a.field == fields[k])
    colNumbers.push(idx)
  }
  return colNumbers
}
